import DirectionalButton from "../../components/DirectionalButton";

function Process({ content }) {
  return (
    <section className="process-section">
      <div className="container">
        <div className="row align-items-end process-heading-row" data-wow="fade-up">
          <div className="col-lg-7 col-md-7">
            <p className="eybrow process-eybrow">
              <img
                className="star-icon"
                src="/assets/images/star.png"
                alt=""
                aria-hidden="true"
              />
              {content.eyebrow}
            </p>
            <h2 className="heading">{content.title}</h2>
            <p className="process-description">{content.description}</p>
          </div>
          <div className="col-lg-5 col-md-5 process-cta-column">
            <DirectionalButton href={content.ctaHref}>
              {content.ctaLabel} <i className="fa-solid fa-arrow-right" />
            </DirectionalButton>
          </div>
        </div>

        <div className="row g-3 process-steps">
          {content.layout.map((item, index) => {
            const step =
              item.type === "card" ? content.steps[item.stepIndex] : null;
            const map =
              item.type === "map" ? content.maps[item.mapIndex] : null;

            return (
              <div
                className="col-md-6 col-lg-3"
                key={`${item.type}-${index}`}
                data-wow="fade-up"
                style={{ "--wow-delay": `${index * 90}ms` }}
              >
                {item.type === "card" ? (
                  <article className="process-card">
                    <div className="process-card-content">
                      <span className="process-number">{step.number}</span>
                      <p className="title">{step.title}</p>
                      <p>{step.description}</p>
                    </div>
                  </article>
                ) : (
                  <div className={`process-map ${item.mapClass}`}>
                    <img
                      src={map.image}
                      className="img-responsive"
                      alt={map.alt}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Process;
